const API_URL = 'https://api.vouppy.com';

export async function fetchStats(apiKey, organizationId) {
  const response = await fetch(
    `${API_URL}/voucher/stats/${organizationId}`,
    {
      headers: {
        'Api-Key': apiKey,
        'Content-Type': 'application/json'
      }
    }
  );
  console.log('Response:', response);
  if (!response.ok) {
    throw new Error('Greška pri učitavanju statistike');
  }

  return response.json();
}

export async function fetchTrendStats(apiKey, organizationId) {
  const response = await fetch(
    `${API_URL}/admin/stats/trend/${organizationId}`,
    {
      headers: {
        'Api-Key': apiKey,
        'Content-Type': 'application/json'
      }
    }
  );

  if (!response.ok) {
    throw new Error('Greška pri učitavanju trend statistike');
  }

  return await response.json();
}

export async function fetchVouchers(apiKey, organizationId) {
  try {
    const response = await fetch(
      `${API_URL}/admin/info/${organizationId}`,
      {
        headers: {
          'Api-Key': apiKey,
          'Content-Type': 'application/json'
        }
      }
    );

    // Loguj status i response
    console.log('Response status:', response.status);
    console.log('Response ok:', response.ok);

    if (!response.ok) {
      // Pokušaj da pročitaš telo odgovora
      const errorText = await response.text();
      console.error('Error response body:', errorText);

      // Pokušaj da parsiraš kao JSON ako je moguće
      try {
        const errorJson = JSON.parse(errorText);
        console.error('Error JSON:', errorJson);
        throw new Error(`Greška ${response.status}: ${errorJson.detail || errorJson.message || errorText}`);
      } catch (parseError) {
        // Ako nije JSON, baci običan tekst
        throw new Error(`Greška ${response.status}: ${errorText}`);
      }
    }

    const data = await response.json();
    console.log('Data:', data.vouchers);
    return data.vouchers;

  } catch (error) {
    console.error('Fetch error:', error);
    console.error('Error message:', error.message);
    console.error('Error stack:', error.stack);
    throw error; // Re-throw da se hendluje gore
  }
}
